import React from 'react';
import ProjectPageLayout from '../../components/ProjectPageLayout';
import SEO from '../../components/SEO';

const Education = () => {
  const history = (
    <>
      <h4>Background</h4>
      <p>
        Since its inception in the 1980s, the National Association for the Blind (NAB) India has been a
        pioneering force in the education and empowerment of visually impaired children. The organization
        began its journey in Mumbai with the introduction of Integrated Education, enabling children with
        visual impairments to study alongside their sighted peers. This evolved into a broader, more
        comprehensive Inclusive Education approach that ensures equal access to quality education for all
        children with disabilities.
      </p>
      <p>
        To date, NAB India has reached over 78,000 visually impaired children, providing them academic
        empowerment and equipping many for careers in government and other sectors.
      </p>
      <p>
        Under this initiative, each educator caters to 12 children across different schools, from early
        childhood to secondary education. The educators teach curriculum and life skills including Braille,
        Taylor's frame, Abacus, mobility &amp; orientation training, and soft skills. They also play a vital role in
        sensitizing communities, parents, teachers, and schools.
      </p>
    </>
  );

  const aimsAndObjectives = (
    <>
      <h4>Collaborations and Government Support</h4>
      <p>
        NAB India has strengthened the Inclusive Education Programme through strategic collaborations and
        government partnerships. Key among these are MoUs with Composite Regional Centres (CRCs)
        under the Ministry of Social Justice &amp; Empowerment, Government of India. These include:
      </p>
      <ul>
        <li>CRC Chhatarpur, Madhya Pradesh</li>
        <li>CRC Jaipur, Rajasthan</li>
        <li>CRC Gorakhpur, Uttar Pradesh</li>
      </ul>
      <p>
        These partnerships have enhanced service delivery, enabled better capacity building, and facilitated
        access to government schemes for children with visual impairments.
      </p>

      <h4>Key Collaborations:</h4>
      <p>
        Education Programme at NAB India is strengthened by strategic institutional partnerships,
        particularly with government-run Special school specially in UP. A notable collaboration is with Govt.
        Blind Inter Colleges operated by the State Government of Uttar Pradesh, located in Lucknow and
        Gorakhpur.
      </p>

      <h4>Digital Empowerment Initiatives</h4>
      <p>
        To ensure that visually impaired children are not left behind in the digital age, NAB India has
        introduced several initiatives under its Digital Empowerment component, currently covering over
        450 visually impaired students with the Govt. Blind School run by UP State Govt. partner
        institutions:
      </p>
      <h5>Computer Literacy Program</h5>
      <p>
        A structured computer education curriculum has been implemented, ranging from basic digital
        literacy (keyboard handling, use of screen readers like NVDA and JAWS) to advanced computer
        operations including MS Office, email communication, internet usage, and accessibility tools. This
        program empowers students to become digitally independent and prepares them for higher
        education and future employment.
      </p>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', margin: '20px 0' }}>
        <img src="/images/Projects/Computer Education in Govt. School-1.jpg" alt="A visually impaired student learning to use a computer with a screen reader." style={{ width: '32%' }} />
        <img src="/images/Projects/Computer Education in Govt. School-2.jpg" alt="A classroom with visually impaired students at their computer stations." style={{ width: '32%' }} />
        <img src="/images/Projects/Computer Education in Govt. School-3.jpg" alt="An instructor guiding a visually impaired student during a computer lesson." style={{ width: '32%' }} />
        <div className="image-gallery" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '20px' }}>
      </div>
      </div>

      <h5>Distribution of Assistive Devices</h5>
      <p>
        As part of our commitment to inclusive learning, Smart Vision Glasses wearable assistive
        devices—have been distributed to selected students. These glasses help the user read printed
        material, recognize faces, and identify objects in real-time, thereby significantly enhancing
        independence and confidence among the visually impaired. Alexa devices have also been distributed
        under the Alexa Community Program to more than 200 inclusive and special schools across 8 states.
      </p>
      <h5>Braille Transcription of Sacred Texts</h5>
      <p>
        Recognizing the importance of spiritual and cultural inclusion, NAB India has transcribed and
        distributed sacred texts such as the Bhagavad Gita and the Ramayan in Braille format. These
        resources are made available free of cost to visually impaired students, enabling them to engage
        meaningfully with India’s rich cultural heritage in an accessible manner.
      </p>
      
      <h4>Programme Activities</h4>
      <p>
        The Inclusive Education Programme of NAB India was implemented across eight
        states—Maharashtra (Mumbai, Solapur, Nashik), Uttar Pradesh (Lucknow, Basti, Varanasi, Agra),
        Madhya Pradesh (Bhopal), Bihar (Jehanabad), Odisha (Nayagarh), Jammu &amp; Kashmir (Kashmir),
        Haryana (Faridabad), and Punjab (Chandigarh). During the 2024-25, a total of 704 children (417 boys
        and 287 girls), including 48 children with Multiple Disabilities with Visual Impairment (MDVI), were
        provided with academic, emotional, and accessibility support. This support was delivered by a
        dedicated team of 54 special educators to ensure the children's effective integration into
        mainstream education.
      </p>
      <p>
        To ensure holistic learning for children with visual impairment, the programme integrates ICT-based
        educational support using digital platforms and digital libraries. Special educators are regularly
        trained to improve instructional quality.
      </p>
      
      <h4>Free distribution of Braille Kits</h4>
      <p>
        Every visually impaired child irrespective of whether he/she is studying in special school or IE
        program must have access to a braille kit. A Braille kit contains basic educational devices needed by
        visually impaired students for learning braille, arithmetic, geometry, etc. So far, over 40,000 braille
        kits have been distributed. In this direction, the department has received support from our well-
        wishers such as Royal Commonwealth Society for the Blind, UK; Jinendra Foundation, UK; Blind
        Foundation of India, USA; Amway Opportunity Foundation; Rotary Foundation’s matching grant
        project; Super Hits Red FM 93.5; Give Foundation; General Insurance Corporation of India; SBI Life
        Insurance Company Ltd., Alkem, Lubrizol CSR initiative etc.
      </p>

      <h4>NAB HINCOL Science Laboratory</h4>
      <p>
        NAB with the support of Hindustan Colas Private Limited (HINCOL) under their CSR initiative set up
        the Science Laboratory in Head Office premises of NAB India. The Science Laboratory was set up with
        the aim to enhance the interest of the visually impaired students in the abstract subject like science
        with maximum exposure towards science practical. It is one of the well-equipped Science labs for
        visually impaired in the country set up by NAB India.
      </p>

      <h4>Accreditation and Training</h4>
      <p>To maintain professional standards and enhance educational quality:</p>
      <h5>IGNOU-Recognized Certificate Course:</h5>
      <ul>
        <li>Certificate in Early Childhood Special Education - Visually Impaired (CESEVI)</li>
        <li>Duration: 1 year (distance learning)</li>
      </ul>
      <h5>Training Centre for Teachers of the Visual Impairment (TCTVI):</h5>
      <ul>
        <li>Established: 2000</li>
        <li>Course: 2-year Diploma in Special Education (Visual Impairment)</li>
        <li>Affiliation: Rehabilitation Council of India (RCI)</li>
        <li>Examinations: Conducted by National Institute for the Empowerment of Persons with Visual Disabilities (NIEPVD)</li>
        <li>Languages: Marathi, Hindi, and English</li>
        <li>Facilities: Lodging and boarding at nominal cost</li>
      </ul>
      <p>Almost all TCTVI graduates are employed in special or inclusive education programs across Maharashtra and other states. TCTVI was awarded a Certificate of Excellence by RCI in 2005.</p>

      <h4>Consultative Services</h4>
      <p>
        Professional staff of the Department participates in various seminars, workshops, training programs
        etc., in consultative capacity. Many of them serve on important committees of the
        Government of India and other vital policy-making bodies.
      </p>

      <h4>Sale of Aids and Equipment</h4>
      <p>
        The Department stocks basic assistive devices used by the visually challenged in education, mobility,
        recreation etc. These items purchased from various manufacturers are made available to individuals
        and organizations, on no profit no loss basis.
      </p>

      <h4>In Conclusion</h4>
      <p>
        The National Association for the Blind (NAB) India has been a trailblazer in the field of education
        for the visually impaired. From pioneering integrated education in the 1980s to leading the
        movement toward inclusive education today, NAB’s impact is both deep and far-reaching. Many
        practices now adopted across disability sectors have their roots in NAB India’s innovative
        approaches for visually impaired learners.
      </p>
      <p>
        Our unwavering mission is to ensure that every child with visual impairment or low vision has
        access to quality education in a supportive and inclusive environment. We are committed to
        providing all necessary academic, technological, and emotional support to empower these
        children to excel in their studies and lead independent, fulfilling lives.
      </p>
    </>
  );

  const contactInfo = (
    <>
      <h4>Ways to Support</h4>
      <p>Your support can transform the lives of children with visually impairment or multiple disabilities with visually impairment. You can contribute through:</p>
      <ol>
        <li>Sponsor one visually impaired child: Rs. 39,900/-</li>
        <li>Support the Inclusive Education Programme for maximum impact</li>
        <li>Donate Braille Kits for free distribution</li>
        <li>Donate groceries for residential TCTVI students</li>
        <li>Sponsor one MDVI (Multiple Disabled Visually Impaired) child: Rs. 39,900/-</li>
        <li>Support Home-Based Programmes for MDVI students</li>
        <li>Donate educational devices: Voice recorders, laptops, braillers, etc.</li>
        <li>Support assistive devices for MDVI students: Customized chairs, therapy balls, sensory toys, mats, splints, etc.</li>
        <li>Contribute to dormitory requirements</li>
      </ol>
      <p>For more information or to support: <br />
      <strong>Mobile:</strong> +91 9372766301 <br />
      <strong>Email:</strong> education@nabindia.info / ie@nabindia.info</p>
    </>
  );

  return (
    <>
      <SEO
        title="Education for the Visually Impaired - NAB India"
        description="Learn about NAB India's inclusive education programs for visually impaired children. We provide academic support, digital literacy, assistive devices, and teacher training to empower students."
        keywords="NAB India education, inclusive education India, education for blind children, digital literacy for visually impaired, assistive devices for students, special education"
      />
      <ProjectPageLayout
        title="Education"
        imageUrl="/images/Projects/education.jpg"
        history={history}
        aimsAndObjectives={aimsAndObjectives}
        contactInfo={contactInfo}
      />
    </>
  );
};

export default Education;
